import ko from 'knockout';
import templateMarkup from 'raw-loader!./link-widget.html';

    function LinkWidget(params) {

        var self = this;

        self.dataProvider = params.dataProvider;
        self.queryParams = params.queryParams;

        self.linkValue = ko.observable(null);

        self.linkVisible = ko.observable(false);

        self.generateLink = function() {
            self.linkValue(null);
            self.linkVisible(false);
            self.dataProvider.getTokenizedLink(self.queryParams ? self.queryParams() : {}, 'pageLink', params.queryId).then(function (link) {
                self.linkValue(link);
                self.linkVisible(true);
            });

            return true;
        };

        //setTimeout(function() {

        //    $("#linkbutton").popover();

        //}, 100);
    }

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    LinkWidget.prototype.dispose = function () {
    };

    export default { viewModel: LinkWidget, template: templateMarkup };
